import type { Namespace, NamespaceFile, NamespaceFileUrl } from './types.js';

export const curriculum: Namespace = import.meta.glob<NamespaceFile>(
    '../locales/*/curriculum.json' satisfies NamespaceFileUrl,
    { eager: true, import: 'default' },
);
